<template>
  <v-card flat>
    <v-card-title>
      Список стандартизированных пациентов
    </v-card-title>
    <v-card-text>
      <v-data-table
          :headers="headers"
          :items="stdpatients"
          :items-per-page="10"
          class="stripped"
          no-data-text="Нет данных"
          :footer-props="{
              itemsPerPageText: 'Строк на странице',
              itemsPerPageOptions: [10, 20, 50, 100, 200]
            }"
      >
        <template #top>
          <v-toolbar flat dense>
            <data-table-filter
                v-if="filters !== null && Object.keys(enabledFilters).length > 0"
                :value="enabledFilters"
                @input="filtersChange"
            />
            <div style="width: 5px" />
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-btn
                    color="primary"
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    @click="downloadExcel">
                  <v-icon>mdi-file-excel</v-icon>
                </v-btn>
              </template>
              Скачать таблицу
            </v-tooltip>
            <div style="width: 5px" />
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-btn
                    color="primary"
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    @click="refetch">
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </template>
              Обновить
            </v-tooltip>
          </v-toolbar>
        </template>
        <template #[`item.date`]="{value}">
          {{ date(value)}}
        </template>
        <template #[`item.studied${year}`]="{value}" v-for="year in years">
          {{ boolConverter(value) }}
        </template>
        <template #[`item.patient${year}`]="{value}" v-for="year in years">
          {{ boolConverter(value) }}
        </template>
        <template #[`item.patientOncologyNews`]="{value}">
          {{ boolConverter(value) }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { dbMixin, dateMixin } from "@/mixins"
import { saveAs } from "file-saver"
import DataTableFilter from "@/components/common/DataTableFilter"

export default {
  name: "StdpatientPage",
  mixins: [dbMixin, dateMixin],
  components: { DataTableFilter },
  data () {
    return {
      filters: {
        fullname: {
          value: '',
          label: 'ФИО стд. пациента',
          type: 'text'
        }
      },
      headers: [
        {
          value: 'date',
          text: 'Дата регистрации',
          width: '50px'
        },
        {
          value: 'region.name',
          text: 'Субъект (Регион)',
          width: '80px'
        },
        {
          value: 'subordinateType.name',
          text: 'Подведомственность организации',
          width: '35px'
        },
        {
          value: 'organization.name',
          text: 'Организация',
          width: '80px'
        },
        {
          value: 'surname',
          text: 'Фамилия',
          width: '60px'
        },
        {
          value: 'firstname',
          text: 'Имя',
          width: '40px'
        },
        {
          value: 'lastname',
          text: 'Отчество',
          width: '40px'
        },
        {
          value: 'position',
          text: 'Занимаемая должность в организации по основному месту работы\n',
          width: '60px'
        },
        {
          value: 'email',
          text: 'Адрес электронной почты (актуальный)',
          width: '40px'
        },
        {
          value: 'patientOncologyNews',
          text: 'Готовность участвовать в роли СП в оценке навыков сообщения «плохих новостей» по специальности «Онкология» в 2026 г.',
          width: '50px'
        },
        {
          value: 'studied2021',
          text: 'Проходил ли обучение в 2021 г.',
          width: '30px'
        },
        {
          value: 'studied2022',
          text: 'Проходил ли обучение в 2022 г.',
          width: '30px'
        },
        {
          value: 'studied2023',
          text: 'Проходил ли обучение в 2023 г.',
          width: '30px'
        },
        {
          value: 'studied2024',
          text: 'Проходил ли обучение в 2024 г.',
          width: '30px'
        },
        {
          value: 'studied2025',
          text: 'Проходил ли обучение в 2025 г.',
          width: '30px'
        },
        {
          value: 'patient2021',
          text: 'Участие в качестве СП в аккредитации 2021 г.',
          width: '30px'
        },
        {
          value: 'patient2022',
          text: 'Участие в качестве СП в аккредитации 2022 г.',
          width: '30px'
        },
        {
          value: 'patient2023',
          text: 'Участие в качестве СП в аккредитации 2023 г.',
          width: '30px'
        },
        {
          value: 'patient2024',
          text: 'Участие в качестве СП в аккредитации 2024 г.',
          width: '30px'
        },
        {
          value: 'patient2025',
          text: 'Участие в качестве СП в аккредитации 2025 г.',
          width: '30px'
        }
      ],
      years: [2021, 2022, 2023, 2024, 2025],
      stdpatients: []
    }
  },
  async beforeMount () {
    await this.refetch()
  },
  computed: {
    enabledFilters () {
      const filters = {}
      let key
      for (key in this.filters) {
        if (this.filters[key].type !== 'hidden') {
          filters[key] = this.filters[key]
        }
      }
      return filters
    },
    urlParams () {
      let params = {}
      if (Object.keys(this.enabledFilters).length > 0) {
        Object.keys(this.filters).forEach(key => {
         if (this.filters[key].value !== null) {
           if (this.filters[key].type === 'text') {
             params[key] = '%' + this.filters[key].value + '%'
           }
           else {
             params[key] = this.filters[key].value
           }
         }
        });
      }
      return params
    }
  },
  methods: {
    async refetch () {
      const url = `${process.env.VUE_APP_SERVER_URL}/roles/stdpatient?`
      let response = await fetch(url + new URLSearchParams(this.urlParams));
      if (response.ok) { // если HTTP-статус в диапазоне 200-299
        // получаем тело ответа (см. про этот метод ниже)
        let items = await response.json();
        this.stdpatients = []
        items.forEach((el) => {
          el = this.convertKeysToCamelCase(el)
          el.region = { uid: el.regionId, name: el.regionName }
          el.organization = { id: el.orgId, name: el.orgName }
          el.subordinateType = { id: el.subId, name: el.subName }
          this.stdpatients.push(el)
        })
      } else {
        alert("Ошибка HTTP: " + response.status);
      }
    },
    async filtersChange (data) {
      for (const item in data) {
        // eslint-disable-next-line vue/no-mutating-props
        this.filters[item].value = data[item].value
      }
      await this.refetch()

    },
    async downloadExcel () {
      const url = `${process.env.VUE_APP_SERVER_URL}/excel/stdpatient`
      saveAs(url, 'Стандартизированные пациенты.xlsx')
    }
  }

}
</script>

<style scoped>

</style>